import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './layouts/stylesheets/index.css';
import App from './App';
import { ApolloProvider, ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { getAuthToken, handleUnauthorized } from './services/auth';


const backendGraphqlUrl =
  process.env.REACT_APP_BACKEND_GRAPHQL_URL || 'https://api.ontrackanalytics.com/graphql';


// Apollo GraphQL setup
// endpoint middleware
const httpLink = createHttpLink({
  uri: backendGraphqlUrl,
});

// authentication middleware
const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  // console.log("pulling auth:", token);
  var more_headers = {};
  if (token)
    more_headers.authorization = token ? `Bearer ${token}` : "";

  return {
    headers: { ...headers, ...more_headers },
  }
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const operationName = operation?.operationName || '';
  const authOperations = new Set([
    'LoginUser',
    'LoginWithGoogle',
    'verifyUserEmail',
    'verifyUserToken',
    'CheckMagicLink',
  ]);

  if (authOperations.has(operationName)) {
    return;
  }

  const graphQLUnauthorized = (graphQLErrors || []).some((error) => {
    const message = `${error?.message || ''} ${error?.extensions?.code || ''}`.toLowerCase();
    return (
      message.includes('unauthor') ||
      message.includes('forbidden') ||
      message.includes('jwt') ||
      message.includes('token') ||
      message.includes('auth')
    );
  });

  const networkStatus = networkError?.statusCode || networkError?.status;
  const networkUnauthorized = networkStatus === 401 || networkStatus === 403;

  if (graphQLUnauthorized || networkUnauthorized) {
    handleUnauthorized();
  }
});

// create the graphql client that we provide to the dom
const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache()
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </BrowserRouter>
);
